import React from "react";
import {
  Box,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const StyledTableCell = styled(TableCell)(() => ({
  borderBottom: "none",
}));

const TypographyVariants = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Typography Variants
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          The typography object comes with 13 variants by default: h1, h2, h3,
          h4, h5, h6, subtitle1, subtitle2, body1, body2, button, caption and
          overline.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          height={"300px"}
          language="js"
          value={
            "" +
            '<Typography variant={"h1"}> h1. Heading</Typography>\n' +
            '<Typography variant={"h2"}> h2. Heading</Typography>\n' +
            '<Typography variant={"h3"}> h3. Heading</Typography>\n' +
            '<Typography variant={"h4"}> h4. Heading</Typography>\n' +
            '<Typography variant={"h5"}> h5. Heading</Typography>\n' +
            '<Typography variant={"h6"}> h6. Heading</Typography>\n' +
            '<Typography variant={"subtitle1"}> This is subtitle1 Text.</Typography>\n' +
            '<Typography variant={"subtitle2"}> This is subtitle2 Text.</Typography>\n' +
            '<Typography variant={"body1"}>This is body1 Text.</Typography>\n' +
            '<Typography variant={"body2"}>This is body2 Text.</Typography>\n' +
            '<Typography variant={"button"}>This is button Text.</Typography>\n' +
            '<Typography variant={"caption"}>This is caption Text.</Typography>\n' +
            '<Typography variant={"overline"}>This is overline Text.</Typography>'
          }
        >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={2}>Variants</StyledTableCell>
                <StyledTableCell>Preview</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <StyledTableCell>h1</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"h1"}> h1. Heading</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>h2</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"h2"}>h2. Heading</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>h3</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"h3"}>h3. Heading</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>h4</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"h4"}>h4. Heading</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>h5</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"h5"}>h5. Heading</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>h6</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"h6"}>h6. Heading</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>subtitle1</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"subtitle1"}>
                    This is subtitle1 Text.
                  </Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>subtitle2</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"subtitle2"}>
                    This is subtitle2 Text.
                  </Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>body1</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"body1"}>This is body1 Text.</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>body2</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"body2"}>This is body2 Text.</Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>caption</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"caption"}>
                    This is caption Text.
                  </Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>button</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"button"}>
                    This is button Text.
                  </Typography>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>overline</StyledTableCell>
                <StyledTableCell>-</StyledTableCell>
                <StyledTableCell>
                  <Typography variant={"overline"}>
                    This is overline Text.
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default TypographyVariants;
